export default __webpack_public_path__ + "static/media/dsppc_cno_img.ee58f0b1.png";